export const PERMISSIONS = {
  DASHBOARD_READ: 'dashboard.read',
  COURSES_READ: 'courses.read',
  COURSES_CREATE: 'courses.create',
  COURSES_UPDATE: 'courses.update',
  COURSES_DELETE: 'courses.delete',
  CLASSES_READ: 'classes.read',
  CLASSES_CREATE: 'classes.create',
  CLASSES_UPDATE: 'classes.update',
  CLASSES_DELETE: 'classes.delete',
  INTAKES_READ: 'intakes.read',
  INTAKES_CREATE: 'intakes.create',
  INTAKES_UPDATE: 'intakes.update',
  SIGNUPS_READ: 'signups.read',
  SIGNUPS_UPDATE: 'signups.update',
  STUDENTS_READ: 'students.read',
  STUDENTS_CREATE: 'students.create',
  STUDENTS_UPDATE: 'students.update',
  STUDENTS_DELETE: 'students.delete',
  TEAM_READ: 'team.read',
  TEAM_INVITE: 'team.invite',
  TEAM_UPDATE: 'team.update',
  TEAM_REMOVE: 'team.remove',
  FINANCE_READ: 'finance.read',
  FINANCE_MANAGE: 'finance.manage',
  SETTINGS_READ: 'settings.read',
  SETTINGS_UPDATE: 'settings.update',
  ROLES_READ: 'roles.read',
  ROLES_MANAGE: 'roles.manage',
};

export const DEFAULT_ROLES = [
  {
    id: 'owner',
    key: 'owner',
    name: 'Owner',
    description: 'Full access to the tenant.',
    permissions: ['*'],
  },
  {
    id: 'administrator',
    key: 'administrator',
    name: 'Administrator',
    description: 'Runs day-to-day operations.',
    permissions: [
      PERMISSIONS.DASHBOARD_READ,
      PERMISSIONS.COURSES_READ,
      PERMISSIONS.COURSES_CREATE,
      PERMISSIONS.COURSES_UPDATE,
      PERMISSIONS.CLASSES_READ,
      PERMISSIONS.CLASSES_CREATE,
      PERMISSIONS.CLASSES_UPDATE,
      PERMISSIONS.INTAKES_READ,
      PERMISSIONS.INTAKES_CREATE,
      PERMISSIONS.INTAKES_UPDATE,
      PERMISSIONS.STUDENTS_READ,
      PERMISSIONS.STUDENTS_CREATE,
      PERMISSIONS.STUDENTS_UPDATE,
      PERMISSIONS.SIGNUPS_READ,
      PERMISSIONS.SIGNUPS_UPDATE,
      PERMISSIONS.TEAM_READ,
      PERMISSIONS.TEAM_INVITE,
      PERMISSIONS.FINANCE_READ,
      PERMISSIONS.SETTINGS_READ,
      PERMISSIONS.SETTINGS_UPDATE,
      PERMISSIONS.ROLES_READ,
    ],
  },
  {
    id: 'instructor',
    key: 'instructor',
    name: 'Instructor',
    description: 'Teaches courses and classes.',
    permissions: [
      PERMISSIONS.DASHBOARD_READ,
      PERMISSIONS.COURSES_READ,
      PERMISSIONS.COURSES_CREATE,
      PERMISSIONS.COURSES_UPDATE,
      PERMISSIONS.CLASSES_READ,
      PERMISSIONS.CLASSES_CREATE,
      PERMISSIONS.INTAKES_READ,
      PERMISSIONS.INTAKES_CREATE,
      PERMISSIONS.STUDENTS_READ,
      PERMISSIONS.SIGNUPS_READ,
    ],
  },
  {
    id: 'accountant',
    key: 'accountant',
    name: 'Accountant',
    description: 'Views and manages finance.',
    permissions: [PERMISSIONS.DASHBOARD_READ, PERMISSIONS.STUDENTS_READ, PERMISSIONS.FINANCE_READ, PERMISSIONS.FINANCE_MANAGE],
  },
  {
    id: 'hr',
    key: 'hr',
    name: 'HR',
    description: 'Manages team operations.',
    permissions: [PERMISSIONS.DASHBOARD_READ, PERMISSIONS.TEAM_READ, PERMISSIONS.TEAM_INVITE],
  },
  {
    id: 'registrar',
    key: 'registrar',
    name: 'Registrar',
    description: 'Manages student records.',
    permissions: [PERMISSIONS.DASHBOARD_READ, PERMISSIONS.STUDENTS_READ, PERMISSIONS.STUDENTS_CREATE, PERMISSIONS.STUDENTS_UPDATE, PERMISSIONS.SIGNUPS_READ, PERMISSIONS.SIGNUPS_UPDATE],
  },
  {
    id: 'student',
    key: 'student',
    name: 'Student',
    description: 'Learner access placeholder for future portals.',
    permissions: [PERMISSIONS.DASHBOARD_READ],
  },
];

export function hasPermission(permissions = [], permission) {
  if (!permission) return true;
  return permissions.includes('*') || permissions.includes(permission);
}
